import { Link } from "react-router-dom";
import { docMenu } from "../../fake-data/New-go-shops-menu";

const allMenus = docMenu.flatMap((menu) => {
  if (menu.routerPath) return menu;
  return menu.dropDownItems;
});

function NavigationBtns() {
  const windowPath = window.location.pathname;
  const currentMenuIdx = allMenus.findIndex(
    (menu) => menu.routerPath === windowPath
  );

  console.log("currentMenuIdx", currentMenuIdx);

  if (currentMenuIdx === -1) return null;

  const currentMenus = (() => {
    if (currentMenuIdx === 0) return [null, allMenus[1]];
    if (currentMenuIdx === allMenus.length - 1)
      return [allMenus[allMenus.length - 2], null];

    return [allMenus[currentMenuIdx - 1], allMenus[currentMenuIdx + 1]];
  })();

  return (
    <div className="center-page-container">
      {currentMenus.map(
        (menu, idx) =>
          menu && (
            <Link to={menu.routerPath} className="btn  previous">
              <p>{idx === 0 ? "Previos" : "Next"}</p>
              <p className="link"> {menu.name} </p>
            </Link>
          )
      )}
    </div>
  );
}

export default NavigationBtns;
